import {Component, OnInit} from '@angular/core';
import {NodeGraphService} from './node-graph.service';
import { ActivatedRoute } from '@angular/router';
import * as Highcharts from 'highcharts';
import HichartsExporting from 'highcharts/modules/exporting.src';
import HichartsExportingCSV from 'highcharts/modules/export-data.src';


HichartsExporting(Highcharts);
HichartsExportingCSV(Highcharts);

@Component({
  selector: 'app-reports',
  templateUrl: './node-graph.component.html',
  styleUrls: ['./node-graph.component.scss']
})
export class NodeGraphComponent implements OnInit {

  nodeId: string;
  title = 'Reports';
  options: Object;
  reportStart: number;
  reportEnd: number;
  graphType = 'spline';
  nodeStatistics: any;
  nodeDataAvailable = true;

  constructor(public route: ActivatedRoute, private nodeGraphService: NodeGraphService) {
  }

  ngOnInit() {
    
    this.reportEnd = Date.now();
    this.reportStart = Date.now() - 604800000; //7 days   
 
    this.nodeId = this.route.snapshot.params.nodeId;
    this.createGraph();
  }

  public onInput(yearMonth: Date): void {

    
    this.reportEnd = Date.now();
    
    
    this.reportStart = Date.now() - 604800000; //7 days
    this.createGraph();
  }
  
  changeGraph(newGraphType: string) {
    this.graphType = newGraphType;
    this.displayGraphs();
  }

  createGraph() {
    
    let nodeRequest = {
      node_id: this.nodeId,
      start_timestamp: Math.round(this.reportStart/1000),
      end_timestamp: Math.round(this.reportEnd/1000) 
    }
        
    this.nodeGraphService.getNodeMetaData(nodeRequest)
      .then(nodeStasticsResult => {
          
        this.nodeStatistics = nodeStasticsResult;
        if (nodeStasticsResult.length !== 0 ) {
            this.nodeDataAvailable = true;
            this.displayGraphs();
        } else {
            this.nodeDataAvailable = false;
        }
      })
  }
  
  private displayGraphs() {
    this.nodeGraph(this.graphType);
  }

  private nodeGraph(graphType) {

    let xAxis = [];
    let series = [];
    let rssi = [];
    let snr = [];
    let batteryLevel = [];
    

    for (let stat of this.nodeStatistics) {
      let date = new Date(stat.timestamp * 1000);

      xAxis.push(date);
      rssi.push(stat.meta_data.last_rssi);
      snr.push(stat.meta_data.last_snr);
      batteryLevel.push(stat.meta_data.battery_level);
    }

    series.push({
      name: 'rssi',
      data: rssi,
      tooltip: {
        valueSuffix: ' dBm'
      },
    });

    series.push({
      name: 'snr',
      data: snr,
      tooltip: {
        valueSuffix: ' dBm'
      },
    });

    series.push({
      name: 'Battery Level',
      data: batteryLevel,
      tooltip: {
        valueSuffix: ' V'
      },
    });

    this.options = {
      chart: {
        type: graphType
      },
      title: {
        text: 'Node Statistics'
      },
      subtitle: {
        text: 'Awesome Node Stats subtitle....'
      },
      xAxis: {
        type: 'datetime',
        categories: xAxis,
        title: {
          text: 'Date'
        }
      },
      yAxis: [{
        min: -130,
        title: {
          text: 'dBm',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      }, {
        min: 0,
        title: {
          text: 'Volts',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      }],
      credits: {
        enabled: false
      },
      series: series,
      exporting: {
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        fallbackToExportServer: false,

        buttons: {
          contextButton: {
            menuItems: ['printChart', 'downloadPNG', 'downloadCSV', 'downloadXLS']
          }
        }
      },
      rangeSelector: {
        inputPosition: {
          align: 'left',
          x: 0,
          y: 0
        },
        buttonPosition: {
          align: 'right',
          x: 0,
          y: 0
        },
      },
    };

    Highcharts.chart('node-data', this.options);
  }

  
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/location-status/node-graphs/node-graph.component.ts